var scope_0 = require('/var/www/medical/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/30fb01570de110e5799a96367e069aa1.js').default;
var scope_1 = require('/var/www/medical/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6bd800d296918dfb10050216ef925df7.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    